import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { IPagination } from '../models/page.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/config/global.config';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent  {
  @Input() pagination?: IPagination | null;
  @Output() toPageEvent = new EventEmitter();

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  pageEvent!: PageEvent;

  labels = {
    of: 'de'
  };

  toPage(number: number, size: number) {
    this.toPageEvent.emit({ number, size });
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.toPage(e.pageIndex + 1, e.pageSize);
  }
}
